import { ApiResponse, Doctor } from '../../types';
import apiClient from '../api/client';
import { delay } from '../mock/delay';
import { mockDoctors } from '../mock/doctors';

export const doctorService = {
  getList: async (): Promise<Doctor[]> => {
    try {
      const response = await apiClient.get<ApiResponse<Doctor[]>>('/doctors/');
      if (response.data.success) {
        return response.data.data;
      } else {
        return [];
      }
    } catch (error) {
      return [];
    }
  },

  create: async (doctor: Doctor): Promise<Doctor> => {
    try {
      const response = await apiClient.post<ApiResponse<Doctor>>('/doctors/', doctor);
      if (response.data.success) {
        return response.data.data;
      } else {
        throw new Error('Failed to create doctor');
      }
    } catch (error) {
      throw new Error('Failed to create doctor');
    }
  },

  update: async (id: string, doctor: Partial<Doctor>): Promise<Doctor> => {
    await delay(800);
    const index = mockDoctors.findIndex((d) => d.id === id);
    if (index === -1) {
      throw new Error('Doctor not found');
    }
    mockDoctors[index] = { ...mockDoctors[index], ...doctor };
    return mockDoctors[index];
  },

  delete: async (id: string): Promise<void> => {
    await delay(500);
    const index = mockDoctors.findIndex((d) => d.id === id);
    if (index !== -1) {
      mockDoctors.splice(index, 1);
    }
  },
};

